import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import axios from "axios";
import ButtonMain from "../../../../../../../../common/components/button/ButtonMain";
import importIcon from "../../../../../../../../../images/ai_image/import.svg";
import { StoreContext } from "../../../../../../../../store/StoreProvider";
import Quota from "../../../component/Quota";
import Act from "../../../../../../../../store/actions";

function handleChange(file, dispatch) {
  let data;
  const reader = new FileReader();
  reader.onload = () => {
    data = reader.result;
    dispatch({
      type: Act.SNA_SET_AI_INPUT_TXT,
      payload: data,
    });
  };
  reader.readAsText(file);
}
function handleUpload(dispatch) {
  const inputTag = document.createElement("input");
  inputTag.type = "file";
  inputTag.accept = ".txt";
  inputTag.addEventListener("change", (e) =>
    handleChange(e.target.files[0], dispatch)
  );
  inputTag.click();
}
const TopPanel = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { currentPage } = sna.AI;

  const intl = useIntl();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "16px",
      }}
    >
      <Box>
        <Typography
          textAlign="left"
          variant="subtitle1"
          sx={{ fontWeight: 700, fontSize: "20px" }}
        >
          {intl.formatMessage({
            id: "sna.sidetool.digitalAITool.ai.title",
            defaultMessage: "AI 語意分析",
          })}
        </Typography>
        {(currentPage === "main" || currentPage === "result") && (
          <Quota text="AI" />
        )}
      </Box>
      <Box>
        {currentPage === "main" && (
          <ButtonMain
            buttonProps={{
              sx: { width: "170px" },
              text: "匯入本機檔案",
              onClick: () => handleUpload(dispatch),
              variant: "linearGradient",
              startIcon: <img src={importIcon} alt="importIcon" />,
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default TopPanel;
